<a href="/" routerlink="/" *ngIf="template == null" (click)="_click()">
  <figure class="logo {{classCustom}}">  
    <img [src]="logo" alt="Logo" [width]="widthLogo" *ngIf="isHome" loading="lazy"/>
    <img [src]="logo2" alt="Logo" [width]="widthLogo" *ngIf="!isHome" loading="lazy" />
  </figure>
</a>
<div class="logo-footer" *ngIf="template == 'footer'">
  <figure class="logo {{classCustom}}">  
    <img [src]="logo" alt="Logo" width="100%" loading="lazy" />
  </figure>
</div> 
